export const getMealOptionName = (name, index) => {
    return name || `Option #${index + 1}`;
};
//# sourceMappingURL=utils.js.map